module.exports = __webpack_public_path__ + "img/blank-comic-book_B098GW5MFT.a3c122f2.jpg";